define( [ "./selector-sizzle" ], function() {
	"use strict";
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/selector.js
// module id = 17
// module chunks = 27